export const css = {
	root: '_2_3XFmZI',
	scoreblock: '_12X4Wf2V',
	legend: '_1Ane2u0e',
	scoreIcon: 'H3_zB42t',
	assessIcon: 'Xf4ri-xB',
	topicGroup: '_3A6lBlB1',
	' _key': 'ascm-theme/ascm/prepost-viz/prepost-viz'
};

export default css;
